<script setup>
const props = defineProps({
  required: {
    type: Boolean,
    default: false
  },
})
</script>

<template>
  <label class="mb-2 flex flex-row items-baseline gap-1 text-sm leading-none">
    <strong class="font-bold text-base md:text-lg leading-none md:leading-none">
      <slot />
    </strong>
    <span v-if="required">(Required)</span>
  </label>
</template>
